import { Injectable, signal } from '@angular/core';
import { APP_VERSION } from '../../version';

@Injectable({
  providedIn: 'root'
})
export class VersionService {
  version = signal<string>(APP_VERSION);
}
